import { types } from 'mobx-state-tree'
import { cities } from '../api'

const CitiesStore = types.model({
  loaded: types.optional(types.boolean, false),
  data: types.optional(types.frozen, [])
}).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get (token) {
      cities(token).then(
        self.fetchCities
      )
    },
    fetchCities (data) {
      self.data = data
      self.loaded = true
    }
  })
).views(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get options () {
      let obj = {}
      return Object.keys(self.data).map((key) => {
        obj = self.data[key]
        return {
          label: obj.name,
          value: obj.id
        }
      })
    }
  })
)

export default CitiesStore



// WEBPACK FOOTER //
// ./src/stores/CitiesStore.js